import { AgGridReact } from 'ag-grid-react'; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { parse } from 'csv-parse/browser/esm';


// enable cors on public
// mui
// upload build, add script and link tags to header on page
// rss to csv cron
// filtered results

export const SearchGrid = () => {

}

export const GridExample = () => {

    const gridRef = useRef();
    const [rowData, setRowData] = useState([
        // { make: "Tesla", model: "Model Y", price: 64950, electric: true },
        // { make: "Ford", model: "F-Series", price: 33850, electric: false },
        // { make: "Toyota", model: "Corolla", price: 29600, electric: false },
    ]);

    // const sizeToFit = useCallback(() => {
    //     gridRef.current.api.sizeColumnsToFit({
    //         defaultMinWidth: 100,
    //         columnLimits: [{ key: 'Form description', minWidth: 200 }],
    //     });
    // }, []);

    const autoSizeStrategy = useMemo(() => {
        return {
            type: 'fitCellContents',
        };
    }, []);

    const autoSizeAll = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef.current.api.getColumns().forEach((column) => {
            allColumnIds.push(column.getId());
        });
        gridRef.current.api.autoSizeColumns(allColumnIds, skipHeader);
    }, []);

    const onGridReady = useCallback((params) => {
        async function startFetching() {
            const response = await fetch(`https://s3.amazonaws.com/webhosting.wellandlighthouse/genflat-table-2.csv?t=${new Date().getTime()}`, { mode: 'cors' });
            const input = await response.text()
            const data = await new Promise((resolve, reject) => {
                parse(input, {
                    columns: true,
                }, function (err, records) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(records);
                    }
                });
            });

            setRowData(data);
        }
        startFetching();

    }, []);



    // Column Definitions: Defines & controls grid columns.
    const [colDefs, setColDefs] = useState([
        { field: "Form type", cellDataType: false, },
        { field: "Form description", cellDataType: false, },
        {
            field: "Filing date", valueGetter: (p) => { return new Date(p.data.filingdate) }, cellRenderer: (v) => {
                return <a href={v.data.filinglink}>{v.data.filingdate}</a>
            },
        },
        { field: "Reporting date", cellDataType: false, },
        { field: "Film number(s)", cellDataType: false, },
        { field: "Accession number", cellDataType: false, },
    ]);
    console.log(rowData);

    return (
        // Container
        <div className="ag-theme-quartz" style={{ height: 500 }}>
            {/* The AG Grid component */}
            <AgGridReact ref={gridRef} autoSizeStrategy={autoSizeStrategy} onGridReady={onGridReady} rowData={rowData} columnDefs={colDefs} />
        </div>
    )
}